export function humanize(str) {
  return str
    .replace(/_/g, " ")
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function getInitials(firstName, lastName) {
  if (!firstName || !lastName) return "";

  const firstInitial = firstName.trim().charAt(0).toUpperCase();
  const lastInitial = lastName.trim().charAt(0).toUpperCase();

  return firstInitial + lastInitial;
}
